/* eslint-disable indent */
import React from 'react';
import { makeStyles } from '~/lib/bn-material-ui';
import { useAccountFeatures } from '~/utility/BinSentry-ui-utility';
import { useOrdersDialogStateSelector } from '../context/orders-dialog-context';
import { OrderSyncToFmmButton } from '../../../components/order-sync-to-fmm-button';

const useStyles = makeStyles(({ palette }) => ({
  subdued: {
    color: palette.gray[60],
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    gap: '1rem',
  },
}));

export function OrdersDialogIntegrationButtons() {
  const styles = useStyles();
  const [selectedOrderId, selectedOrderEntity, selectedBarnId] = useOrdersDialogStateSelector(['selectedOrderId', 'selectedOrderEntity', 'selectedBarnId']);
  const { features } = useAccountFeatures({ organizationId: selectedBarnId });

  return (
    <div className={styles.container}>
      {selectedOrderId ? <>
        {features?.fmm && <OrderSyncToFmmButton orderEntity={selectedOrderEntity} />}
      </> : null}
    </div>
  );
}
